module.exports = __webpack_public_path__ + "static/media/cm.e23c4140.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/ruler/cm.svg
 ** module id = 198
 ** module chunks = 0
 **/